import { ProfilePicture } from './ProfilePicture';
import './PickedHighlightRow.css';

const PickedHighlightRow = ({ preview }) => <li className='pickedHighlightRow'>
    <div className='pickedHighlightContents'>
        <div className='pickedHighlightAvatar' aria-hidden='true'>
            <ProfilePicture speakerId={preview.person?.id} imageSrc={preview.person?.imageURL} size='48px' borderSize={1} />
        </div>
        <div className='pickedHighlightText'>
            <div className='pickedHighlightSpeaker'>{preview.person?.name || 'Your selected speaker'}</div>
            <div className='pickedHighlightTitle'>{preview.title || 'Another highlight from your picks'}</div>
        </div>
    </div>
</li>;

export default PickedHighlightRow;
